module.exports = __webpack_public_path__ + "acc386cdada74cda61942761b83d7b8e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-left-26.png
// module id = 2570
// module chunks = 0